import React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Typography from '@mui/joy/Typography';
import CircularProgress from '@mui/joy/CircularProgress';

/**
 * Phone vs registration selects — shared by Deploy (listener) and OutboundCallSetup (caller ID).
 * @param {'deploy' | 'originate'} purpose
 * @param {'phone' | 'registration' | null} callerKind - null = show type toggle (originate); fixed = one column only (deploy modal)
 */
export default function TelephonyCallerEndpointFields({
  purpose,
  callerKind = null,
  kind,
  onKindChange,
  phoneNumbers,
  registrations,
  loading,
  selectedPhone,
  onSelectedPhone,
  selectedRegistrationId,
  onSelectedRegistrationId,
  emptyPhoneHint,
  emptyRegistrationHint,
}) {
  const showToggle = callerKind == null;
  const effectiveKind = callerKind != null ? callerKind : kind;
  const showPhone = effectiveKind === 'phone';
  const showReg = effectiveKind === 'registration';

  return (
    <>
      {showToggle && (
        <FormControl sx={{ mb: 2 }}>
          <FormLabel>{purpose === 'originate' ? 'Caller ID type' : 'Listener type'}</FormLabel>
          <Select
            value={kind}
            onChange={(_, v) => onKindChange(v ?? 'phone')}
            sx={{ minWidth: 280 }}
          >
            <Option value="phone">Phone number (PSTN / allocated DDI)</Option>
            <Option value="registration">Registration (SIP registration endpoint)</Option>
          </Select>
        </FormControl>
      )}

      {showPhone && (
        <FormControl sx={{ mb: 2 }}>
          <FormLabel>{purpose === 'originate' ? 'Outbound caller number' : 'Allocated number'}</FormLabel>
          {loading ? (
            <CircularProgress size="sm" />
          ) : phoneNumbers.length === 0 ? (
            <Typography level="body-sm" textColor="neutral.600">
              {emptyPhoneHint}
            </Typography>
          ) : (
            <Select
              placeholder="Select number…"
              value={selectedPhone || null}
              onChange={(_, v) => onSelectedPhone(v ?? '')}
              sx={{ minWidth: 280 }}
            >
              {phoneNumbers.map((p) => (
                <Option key={p.number} value={p.number}>
                  {p.number} ({p.handler})
                </Option>
              ))}
            </Select>
          )}
        </FormControl>
      )}

      {showReg && (
        <FormControl sx={{ mb: 2 }}>
          <FormLabel>{purpose === 'originate' ? 'Registration endpoint (caller ID)' : 'Registration endpoint'}</FormLabel>
          {loading ? (
            <CircularProgress size="sm" />
          ) : registrations.length === 0 ? (
            <Typography level="body-sm" textColor="neutral.600">
              {emptyRegistrationHint}
            </Typography>
          ) : (
            <Select
              placeholder="Select registration…"
              value={selectedRegistrationId || null}
              onChange={(_, v) => onSelectedRegistrationId(v ?? '')}
              sx={{ minWidth: 280 }}
            >
              {registrations.map((r) => (
                <Option key={r.id} value={r.id}>
                  {(r.name || r.registrar || r.id) +
                    (r.username ? ` — ${r.username}` : '') +
                    (r.handler ? ` (${r.handler})` : '')}
                </Option>
              ))}
            </Select>
          )}
        </FormControl>
      )}
    </>
  );
}
